[
  {
    "campaign": "Etherfi.json"
  },
  {
    "campaign": "Symbiotic.json"
  },
  {
    "campaign": "Fraxtal.json"
  },
  {
    "campaign": "Lombard.json"
  },
  {
    "campaign": "Fx.json"
  },
  {
    "campaign": "Infinifi.json"
  },
  {
    "campaign": "Falcon.json"
  },
  {
    "campaign": "Loop.json"
  },
  {
    "campaign": "Noon.json"
  },
  {
    "campaign": "Aegis.json"
  },
  {
    "campaign": "Yuzu.json"
  },
  {
    "campaign": "TermMax.json"
  },
  {
    "campaign": "Re.json"
  },
  {
    "campaign": "Raac.json"
  },
  {
    "campaign": "Yld.json"
  },
  {
    "campaign": "Tangent.json"
  },
  {
    "campaign": "Apyx.json"
  },
  {
    "campaign": "Jane.json"
  },
  {
    "campaign": "Tori.json"
  },
  {
    "campaign": "Axis.json"
  }
]
